


















































import { Component, Prop, Vue } from "vue-property-decorator";

@Component
export default class Radio extends Vue {
  @Prop({}) readonly radioList!: any;
  @Prop({ required: true }) readonly checked!: boolean;
  @Prop({ default: false }) readonly disabled!: boolean;
  @Prop({ default: "" }) readonly name!: string;
  @Prop({ default: "" }) readonly label!: string;
  @Prop({ default: "" }) readonly tooltip!: string | Array<any>;

  private id = "";

  created() {
    this.id = Math.random()
      .toString(36)
      .substring(7);
  }
}
